import Styled from 'styled-components';

const HeaderContainer = Styled.div`
`;

const DataWrapper = Styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  margin-bottom: 20px;
  
`;

const DistributionWrapper = Styled.div`
  width: 92%;
  margin: 16px 0 0 0;
  padding-top: 16px;
  border-top: 1px solid #E9E9E9;

  > div {
    width: 100%;

    > div {
      width: 100%;

      > div {
        &:nth-child(2) {
          width: 100%;
        }
      }

      > span {
        min-width: 45px;
      }
    }
  }
`;

const Text = Styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 100%;
  color: #666666;
  margin-left: -150px;
`;

const Wrapper = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-left: 1px solid #E9E9E9;
  border-right: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9;
`;

const TitleBox = Styled.div`
  border-top: 1px solid #E9E9E9;
  border-left: 1px solid #E9E9E9;
  border-right: 1px solid #E9E9E9;
  border-radius: 8px 8px 0 0;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  color: #575757;
  padding: 16px;
  background: #FAFAFA;
`;

export { HeaderContainer, DataWrapper, DistributionWrapper, Text, Wrapper, TitleBox };
